import AddCampaignGig from 'Components/campaigns/collaborations/milestones/AddCampaignGig';
import CampaignGig from 'Components/campaigns/create-edit/CampaignGig';
import RadioTileGroup from 'Components/input/RadioTileGroup/RadioTileGroup';
import { PRIVILEGE } from 'constants/privilege';
import withAccessControl from 'hoc/withAccessControl';
import { usePrivileges } from 'hooks/useAuth';
import CampaignCreationLayout from 'Layouts/CampaignCreationLayout'
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Button, Input, InputGroup, Spinner } from 'reactstrap';
import { updateCampaignMilestone, updateMilestoneGigs } from 'services/api/campaign';
import { fetchCampaignGigsThunk, fetchCampaignMilestonesThunk } from 'slices/campaigns/milestones/thunk';
import { useGetCampaignCurrency } from 'slices/campaigns/selector';
import { AppDispatch, RootState } from 'store';
import { Milestone } from 'types/campaign/collaborations';
import { isValidURL } from 'utils/helpers';

const CampaignProduct: React.FC<{ viewOnly?: boolean }> = ({ viewOnly }) => {
    const { campaignId } = useParams();
    const privileges = usePrivileges();
    const dispatch = useDispatch<AppDispatch>();
    const currency = useGetCampaignCurrency(campaignId!);

    const milestonesData = useSelector((state: RootState) => state.campaignMilestones.items[campaignId!]?.milestonesData);
    const campaignMilestones = milestonesData?.milestones ?? [];
    const gigTypes = milestonesData?.gig_types ?? [];
    const properties = milestonesData?.properties ?? {};

    const campaignGigs = useSelector((state: RootState) => state.campaignMilestones.gigs[campaignId!]?.items || []);
    const campaignMilestone = (Array.isArray(campaignMilestones) && campaignMilestones.length > 0) ? campaignMilestones[0] : null;

    const [milestone, setMilestone] = useState(campaignMilestone ?? null);
    const milestoneGigType = (gigTypes ?? []).find((gigType) => gigType.id && milestone?.gig_type_id && gigType.id === milestone.gig_type_id);
    const milestoneGigs = (campaignGigs ?? []).filter((gig) => (milestone?.campaign_gig_ids ?? []).includes(gig.id))
    const [addGigModalOpen, setAddGigModalOpen] = useState(false);
    const [selectedGigId, setSelectedGigId] = useState<number | null>(null);
    const [campaignGigsRefetchRequired, setCampaignGigsRefetchRequired] = useState(false);
    const campaignGigsRefetchRequiredRef = useRef<ReturnType<typeof setTimeout> | null>(null);
    const [errors, setErrors] = useState<Record<string, string>>({});
    const [updating, setUpdating] = useState<boolean>(false);
    const navigate = useNavigate();
    const [productDelivery, setProductDelivery] = useState<string | null>(null);


    const [searchParams] = useSearchParams();
    const validate = searchParams.get('validate');
    const [validatedOnce, setValidatedOnce] = useState(false);


    useEffect(() => {
        if(!milestoneGigType || productDelivery) return;
        if(milestone?.specifications?.purchase_required) {
            setProductDelivery('reimbursement');
        }else{
            console.log('here1')
            if(milestoneGigType?.slug === 'store_visit' && Number(milestone?.barter_amount) === 0){
                console.log('here2')
                setProductDelivery('not_required');
            }else{
                console.log('here3', Number(milestone?.barter_amount))
                setProductDelivery('shipment');
            }
        }
    }, [milestoneGigType, productDelivery, milestone])


    useEffect(() => {
        setMilestone(campaignMilestone ?? null);
    }, [campaignMilestone])

    useEffect(() => {
        if (campaignId) {
            dispatch(fetchCampaignGigsThunk(campaignId));
        }
    }, [campaignId])

    useEffect(() => {
        if(validate === 'true' && milestone && !validatedOnce){
            validateMilestoneData();
            setValidatedOnce(true);
        }
    }, [validate, milestone, validatedOnce])


    const removeMilestoneGig = async (gigId: number) => {
        const milestoneId = milestone?.id;

        if (!campaignId || !milestoneId || viewOnly) return;

        const currentCampaignGigs = Array.isArray(milestone?.campaign_gig_ids) ? [...milestone?.campaign_gig_ids] : [];
        const updatedCampaignGigs = currentCampaignGigs.filter((gig) => gig !== gigId);

        try {
            await updateMilestoneGigs(campaignId, milestoneId, updatedCampaignGigs);
            await dispatch(fetchCampaignGigsThunk(campaignId));
            updateMilestoneGigsLocal(updatedCampaignGigs);
            // setMilestoneGigsUpdateStatus({ status: 'success', message: `${getGigType(milestone?.gig_type_id)?.object_name} deleted successfully!` });
        } catch (error: any) {
            console.log(error);
            // setMilestoneGigsUpdateStatus({ status: 'danger', message: error?.response?.data?.message ?? `Failed to delete ${getGigType(milestone?.gig_type_id)?.object_name}` });
        }
    }


    const updateMilestoneGigsLocal = (updatedCampaignGig: number[]) => {
        if (!milestone) return;
        const updatedMilestone = { ...milestone }
        updatedMilestone.campaign_gig_ids = updatedCampaignGig;

        if (milestoneGigType?.slug === 'product_review') {
            const maxReimbursementBudget = getMaxReimbursementBudget();

            updatedMilestone.barter_amount = maxReimbursementBudget;
        }

        setMilestone(updatedMilestone);
    }

    const attachCampaignGig = async (gigId: number) => {

        const milestoneId = milestone?.id;

        if (!campaignId || !milestoneId) return;

        const currentCampaignGigs = Array.isArray(milestone?.campaign_gig_ids) ? [...milestone?.campaign_gig_ids] : [];
        const updatedCampaignGig = !currentCampaignGigs.includes(gigId) ? [gigId, ...currentCampaignGigs] : currentCampaignGigs;

        try {
            await updateMilestoneGigs(campaignId, milestoneId, updatedCampaignGig);
            await dispatch(fetchCampaignGigsThunk(campaignId));
            updateMilestoneGigsLocal(updatedCampaignGig);
            setAddGigModalOpen(false);
            setSelectedGigId(null);
            setCampaignGigsRefetchRequired(true);
        } catch (error: any) {
            // setMilestoneGigsUpdateStatus({ status: 'danger', message: error?.response?.data?.message ?? `Failed to add ${getGigType(milestones[milestoneIndex]?.gig_type_id)?.object_name}` });
        }
    }

    useEffect(() => {
        if (campaignGigsRefetchRequiredRef.current) {
            clearTimeout(campaignGigsRefetchRequiredRef.current);
        }
        if (campaignGigsRefetchRequired) {
            campaignGigsRefetchRequiredRef.current = setTimeout(() => {
                if (campaignId) {
                    dispatch(fetchCampaignGigsThunk(campaignId)).then(() => {
                        setCampaignGigsRefetchRequired(false);
                    });
                }
            }, 30000);
        }
    }, [campaignGigsRefetchRequired]);



    const handleMilestoneChange = (key: string, value: any) => {
        if (!milestone) return;
        const updatedMilestone: Milestone = {
            ...milestone,
            [key]: value
        };
        if (key === 'maximum_gigs') {
            updatedMilestone.barter_amount = getMaxReimbursementBudget(value);
        }
        setMilestone(updatedMilestone);
    }

    const handleSpecificationsChange = (key: string, value: any) => {
        if (!milestone) return;
        const updatedMilestone: Milestone = {
            ...milestone,
            specifications: {
                ...milestone.specifications,
                [key]: value
            }
        };
        setMilestone(updatedMilestone);
    }

    const getMaxReimbursementBudget = (maxGigs = milestone?.maximum_gigs ?? 0): number => {

        return [...milestoneGigs]
            .sort((a, b) => (Number(b.value) || 0) - (Number(a.value) || 0))
            .slice(0, maxGigs)
            .reduce((sum, gig) => sum + (Number(gig.value) || 0), 0);
    };

    const validateMilestoneData = () => {
        const newErrors: Record<string, string> = {};
        if (['product_review', 'store_visit'].includes(milestoneGigType?.slug ?? '')) {
            if (milestone?.specifications?.purchase_required === undefined) {
                newErrors['purchase_required'] = 'Please select a product delivery method.';
            }
            if ((!Number(milestone?.barter_amount) || Number(milestone?.barter_amount) <= 0) && productDelivery !== 'not_required') {
                newErrors['barter_amount'] = 'Please enter a valid amount greater than 0.';
            }
            if (milestoneGigType?.slug === 'product_review') {
                if (!milestone?.maximum_gigs || milestone?.maximum_gigs <= 0) {
                    newErrors['maximum_gigs'] = 'Please enter the number of products to review.';
                }
            }
            if (milestoneGigType?.slug === 'store_visit' && !milestone?.specifications?.gig_selection && !milestone?.specifications?.store_name) {
                newErrors['store_name'] = `Store name is required.`;
            }
            if (milestoneGigType?.slug === 'product_review' && !milestone?.specifications?.gig_selection) {
                if(!milestone?.specifications?.website_url){
                    newErrors['website_url'] = `Website URL is required.`;
                }
                if(milestone?.specifications?.website_url && !isValidURL(milestone?.specifications?.website_url ?? '')){
                    newErrors['website_url'] = `Please enter a valid URL.`;
                }
            }
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    }

    const updateMilestone = async () => {

        if (!campaignId || !milestone || !milestoneGigType || updating || viewOnly) return false;

        const isValid = validateMilestoneData();

        if (!isValid) return false;
        setUpdating(true);
        const updatedMilestone = { ...milestone, barter_reimbursement: productDelivery === 'reimbursement' };
        if(productDelivery === 'not_required'){
            updatedMilestone.barter_amount = 0;
        }
        updatedMilestone.specifications = {
            ...updatedMilestone.specifications,
            purchase_required: productDelivery === 'reimbursement',
        }

        try {
            await updateCampaignMilestone(campaignId, String(milestone.id), updatedMilestone);
            dispatch(fetchCampaignMilestonesThunk(campaignId));
            navigate(`/campaign/${campaignId}/creators`);
        } catch (error: any) {
            toast.error(error?.response?.data?.message ?? "Failed to update milestone!")
        } finally {
            setUpdating(false);
        }
    }

    useEffect(() => {
        if (milestoneGigType?.slug === 'brand_promotion' && campaignId && !viewOnly) {
            navigate(`/campaign/${campaignId}/creators`)
        }
    }, [milestoneGigType, campaignId, viewOnly])

    return (
        <>
            <CampaignCreationLayout
                viewOnly={viewOnly}
                activeStep='gigs'
                actionRow={
                    <div className="d-flex justify-content-between mb-4">
                        <div></div>
                        <button onClick={updateMilestone} type='button' disabled={updating || !privileges.includes(PRIVILEGE.CAMPAIGN.CAMPAIGN.EDIT)} className="theme-btn theme-btn-lg btn-gradient form-continue-btn d-flex justify-content-between align-items-center">
                            <React.Fragment>
                                {
                                    'Proceed to Next'
                                }
                                {
                                    updating ? <Spinner size="sm" className='me-2'> Loading... </Spinner> : <i className='bx fs-4 bx-right-arrow-alt' ></i>
                                }
                            </React.Fragment>
                        </button>
                    </div>
                }
            >
                {
                    ['product_review', 'store_visit'].includes(milestoneGigType?.slug ?? '') && properties?.purchase_required &&
                    <>
                        <div className="form-group">
                            <div className="d-flex flex-column">
                                <h6>Product Delivery <span className="text-danger">*</span></h6>
                                {
                                    milestoneGigType?.slug === 'store_visit' ? (
                                        <span className='field-desc'>{properties?.purchase_required?.label}</span>
                                    ) : (
                                        <span className='field-desc'>Choose how you want Creators to receive the product</span>
                                    )
                                }
                            </div>
                            <RadioTileGroup
                                disabled={viewOnly}
                                options={[
                                    ...(milestoneGigType?.slug === 'store_visit' ? [{ id: 'not_required', label: "Not Required", info: 'No product required' }] : []),
                                    { id: 'reimbursement', label: "I'll reimburse", info: 'Pay creator to buy product(s)' },
                                    { id: 'shipment', label: "I'll provide the product(s)", info: 'Send product(s) directly to the creator' },
                                ]}
                                defaultValue={productDelivery ?? ''}
                                onChange={(val) => {
                                    setProductDelivery(val);
                                }}
                                name='product-delivery'
                            />
                            {errors['purchase_required'] &&
                                <span className="text-danger">{errors['purchase_required']}</span>
                            }
                        </div>
                        {
                            milestoneGigType?.slug === 'product_review' &&
                            <div className="form-group mt-4">
                                <div className="d-flex flex-column">
                                    <label htmlFor="max-gigs">Number of products to review <span className="text-danger">*</span></label>
                                    <span className='field-desc'>Specify the number of products each Creator should review</span>
                                </div>
                                <input
                                    type="number"
                                    disabled={viewOnly}
                                    id="max-gigs"
                                    className="form-control"
                                    value={milestone?.maximum_gigs || ''}
                                    onChange={(e) => handleMilestoneChange('maximum_gigs', Number(e.target.value) ? Number(e.target.value) : '')}
                                    placeholder="Enter number of products" />
                                {errors['maximum_gigs'] &&
                                    <span className="text-danger">{errors['maximum_gigs']}</span>
                                }
                            </div>
                        }
                        {
                            productDelivery !== 'not_required' &&
                            <div className="form-group mt-4">
                                <div className="d-flex flex-column">
                                    <label htmlFor="product-value">{productDelivery === 'reimbursement' ? 'Reimbursement' : 'Barter'} value <span className="text-danger">*</span></label>
                                    <span className='field-desc'>Enter the estimated value of the product(s) to be provided to each Creator.</span>
                                </div>
                                <InputGroup>
                                    <Input
                                        disabled={viewOnly}
                                        type="number"
                                        id="product-value"
                                        className="form-control"
                                        value={milestone?.barter_amount ?? ''}
                                        onChange={(e) => handleMilestoneChange('barter_amount', Number(e.target.value) ? Number(e.target.value) : '')}
                                        placeholder={`Enter ${milestone?.specifications?.purchase_required ? 'reimbursement' : 'barter'} value`} />
                                    {
                                        milestoneGigType?.slug === 'product_review' &&
                                        <Button title="Calculate" className="theme-btn theme-btn-lg btn-gradient" style={{ marginLeft: '-5px', height: '38px' }} onClick={() => {
                                            const maxReimbursementBudget = getMaxReimbursementBudget();
                                            handleMilestoneChange('barter_amount', maxReimbursementBudget);
                                        }}><i className=" bx bx-calculator" /></Button>
                                    }
                                </InputGroup>
                                {errors['barter_amount'] &&
                                    <span className="text-danger">{errors['barter_amount']}</span>
                                }
                            </div>
                        }
                        <div className="divider my-5"></div>
                    </>
                }
                {
                    ['store_visit', 'product_review'].includes(milestoneGigType?.slug ?? '') ? (
                        <>
                            <div className="form-group">
                                <div className="d-flex flex-column">
                                    <label htmlFor="store-selection">{milestoneGigType?.slug === 'store_visit' ? 'Store Selection' : 'Product Selection'} <span className="text-danger">*</span></label>
                                    <span className='field-desc'>{milestoneGigType?.slug === 'store_visit' ? 'Select how the creator will be able to select their preferred store.' : 'Select how the creator will be able to select their preferred product(s).'}</span>
                                </div>
                                <RadioTileGroup
                                    disabled={viewOnly}
                                    name='gig_selection'
                                    options={[
                                        { id: 'list', label: "I'll provide the list", info: `Creator will be able to select their preferred ${milestoneGigType?.slug === 'store_visit' ? 'store' : 'product(s)'} from the list` },
                                        ...(milestoneGigType?.slug === 'store_visit' ? [{ id: 'find_nearby', label: "Show nearby stores", info: 'Creator will be able to find nearby stores' }] : []),
                                        ...(milestoneGigType?.slug === 'product_review' ? [{ id: 'choose_from_website', label: "Choose from website", info: 'Creator will be able to choose their preferred product(s) from the website' }] : [])
                                    ]}
                                    defaultValue={milestone?.specifications?.gig_selection ? 'list' : (milestoneGigType?.slug === 'store_visit' ? 'find_nearby' : 'choose_from_website')}
                                    onChange={(value) => handleSpecificationsChange('gig_selection', (value === 'list'))}
                                />
                            </div>
                            {
                                milestone?.specifications?.gig_selection ? (
                                    <div className='mt-5'>
                                        {
                                            milestoneGigs.length > 0 ? (
                                                <React.Fragment>
                                                    {
                                                        milestoneGigs.map((gig, i) => (
                                                            <CampaignGig
                                                                currency={currency}
                                                                viewOnly={viewOnly}
                                                                gig={gig}
                                                                onDelete={() => {
                                                                    if (!milestone) return;
                                                                    removeMilestoneGig(gig.id)
                                                                }}
                                                                onEdit={() => {
                                                                    setSelectedGigId(gig.id);
                                                                    setAddGigModalOpen(true);
                                                                }}
                                                                key={i} />
                                                        ))
                                                    }
                                                    <div className="d-flex align-items-center justify-content-end">
                                                        <button type="button" onClick={() => setAddGigModalOpen(true)} className="btn btn-link p-0">+ Add {milestoneGigType?.object_name}</button>
                                                    </div>
                                                </React.Fragment>
                                            ) : (
                                                <div className="d-flex w-100 justify-content-center align-items-center">
                                                    <div className="length-zero m-0 flex-column">
                                                        <h3>Currently there is no {milestoneGigType?.object_name?.toLowerCase()} in your list</h3>
                                                        <button className='btn btn-white gap-2' onClick={() => setAddGigModalOpen(true)}> <i className='ri-add-line'></i> Add {milestoneGigType?.object_name}</button>
                                                    </div>
                                                </div>
                                            )
                                        }
                                    </div>
                                ) : (
                                    <div className="form-group mt-4">
                                        <div className="d-flex flex-column">
                                            <label htmlFor="store-name">{milestoneGigType?.slug === 'store_visit' ? 'Store Name' : 'Website URL'} <span className="text-danger">*</span></label>
                                            <span className='field-desc'>{milestoneGigType?.slug === 'store_visit' ? 'Enter the name of the store where creators will visit.' : 'Enter the URL of the website where creators will choose their preferred product(s).'}</span>
                                        </div>
                                        <input
                                            disabled={viewOnly}
                                            type="text"
                                            id={milestoneGigType?.slug === 'store_visit' ? 'store-name' : 'website-url'}
                                            className='form-control'
                                            value={milestoneGigType?.slug === 'store_visit' ? milestone?.specifications?.store_name ?? '' : milestone?.specifications?.website_url ?? ''}
                                            placeholder={milestoneGigType?.slug === 'store_visit' ? 'Store Name' : 'Website URL'}
                                            onChange={(e) => {
                                                handleSpecificationsChange(milestoneGigType?.slug === 'store_visit' ? 'store_name' : 'website_url', e.target.value);
                                            }}
                                        />
                                        {milestoneGigType?.slug === 'store_visit' && errors['store_name'] &&
                                            <span className="text-danger">{errors['store_name']}</span>
                                        }
                                        {milestoneGigType?.slug === 'product_review' && errors['website_url'] &&
                                            <span className="text-danger">{errors['website_url']}</span>
                                        }
                                    </div>
                                )

                            }

                        </>
                    ) : (
                        <>
                            {
                                milestoneGigs.length > 0 ? (
                                    <React.Fragment>
                                        {
                                            milestoneGigs.map((gig, i) => (
                                                <CampaignGig
                                                    currency={currency}
                                                    gig={gig}
                                                    onDelete={() => {
                                                        if (!milestone) return;
                                                        removeMilestoneGig(gig.id)
                                                    }}
                                                    onEdit={() => {
                                                        setSelectedGigId(gig.id);
                                                        setAddGigModalOpen(true);
                                                    }}
                                                    key={i} />
                                            ))
                                        }
                                        <div className="d-flex align-items-center justify-content-end">
                                            <button type="button" onClick={() => setAddGigModalOpen(true)} className="btn btn-link p-0">+ Add {milestoneGigType?.object_name}</button>
                                        </div>
                                    </React.Fragment>
                                ) : (
                                    <div className="d-flex w-100 justify-content-center align-items-center">
                                        <div className="length-zero m-0 flex-column">
                                            <h3>Currently there is no {milestoneGigType?.object_name?.toLowerCase()} in your list</h3>
                                            <button className='btn btn-white gap-2' onClick={() => setAddGigModalOpen(true)}> <i className='ri-add-line'></i> Add {milestoneGigType?.object_name}</button>
                                        </div>
                                    </div>
                                )
                            }

                        </>
                    )
                }


            </CampaignCreationLayout>
            <AddCampaignGig
                currency={currency}
                isOpen={addGigModalOpen}
                selectedGigId={selectedGigId!}
                gigType={milestoneGigType!}
                onClose={() => {
                    setAddGigModalOpen(false);
                    setSelectedGigId(null);
                }}
                campaignGigIds={milestone?.campaign_gig_ids || []}
                addCampaign={(gigId) => {
                    attachCampaignGig(gigId);
                    setAddGigModalOpen(false);
                    setSelectedGigId(null);
                }}
                campaignGigs={campaignGigs}
            />
        </>

    )
}

export default withAccessControl(CampaignProduct, PRIVILEGE.CAMPAIGN.CAMPAIGN.EDIT)
